import {ILanguage} from "../../models/application-parameters/language.interface";
import {IAppParamData} from "../../models/application-parameters/application-parameters.interface";


export interface IMDMParam {
  type: string;
  hierCode: string;
  hierLevel: string;
  data: Array<string>;
}


export interface ILanguageState {
  availableLanguages: Array<ILanguage>;
  currentLanguage: string;

}
export const initialLanguageState:ILanguageState = {
  availableLanguages:[
    {
      code:'ru',
      displayCode:'RU',
      name: 'Русский',
      icon: '',
      isActive: true
    },
    {
      code:'ro',
      displayCode:'RO',
      name: 'Românesc',
      icon: '',
      isActive: true
    },
    {
      code:'en',
      displayCode:'EN',
      name: 'English',
      icon: '',
      isActive: true
    },
    {
      code:'uk',
      displayCode: 'UA',
      name: 'Український',
      icon: '',
      isActive: true
    }
  ],
  currentLanguage: 'en'
};

export interface IReportParametersState {
  lastParamCode: string;
  params:Array<IAppParamData>;

}
export const initualReportParametersState:IReportParametersState = {
  lastParamCode: '',
  params:[]
};


export interface IApplicationParametersState {
  selectedSupplierCode: string; //Код поставщика

  selectedOrganisationCode: string; //Код подразделения организации, например магазин
  selectedOrganisationCodeList: Array<string>; //Список кодов подразделений организации, например магазинов
  selectedOrganisationLevel: string; // Уровень, на котором происходит отбор данных по магазинам

  selectedNomenclatureCode: string;
  selectedNomenclatureCodeList: Array<string>;
  selectedNomenclatureLevel: string;

  selectedDateFrom: string;
  selectedDateTo: string;
  selectedDateLevel: string;

  selectedDatasourcePartyId: string;

  selectedFinDepartment: string; //Финансовое подразделение. Используется в extranet Ашан

  selectedOsaIncidentSelection: string; // Выбор событий OSA - все или по списку
  selectedOsaIncidentType: Array<Array<string>>; //Типы инцидентов. первый уровень массива - массив уровней, каждый уровень содержит конкретные значения выбранных типов на этом уровне
  selectedOsaIncidentKind: string; // вид причины - расчитанные или модифицированные

  selectedReportParam:IReportParametersState;


}

export const initialApplicationParametersState:IApplicationParametersState = {
  selectedSupplierCode: '',

  selectedOrganisationCode: 'TOTAL',
  selectedOrganisationCodeList: [],
  selectedOrganisationLevel: '1',

  selectedNomenclatureCode: 'TOTAL',
  selectedNomenclatureCodeList: [],
  selectedNomenclatureLevel: '1',

  selectedDateFrom: 'CALENDAR_MONTH_201904',
  selectedDateTo: 'CALENDAR_MONTH_201904',

  selectedDateLevel: 'MONTH',
  selectedDatasourcePartyId: null,
  selectedFinDepartment: null,

  selectedOsaIncidentSelection: '',
  selectedOsaIncidentType: [],
  selectedOsaIncidentKind: '',

  selectedReportParam: initualReportParametersState


};
